import React, { useState } from "react";
import { Card, Tab, Nav } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import VerificationRequestsTable from "./VerificationRequestsTable";
import { useLocation, useNavigate } from "react-router-dom";
import FaceVerification from "./FaceVerification";
import ReuploadFaceVerification from "./ReuploadFaceVerification";
import ReuploadProfileVerification from "./ReuploadProfileVerification";

export default function FaceTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(
    location?.state?.selectedTab ? location?.state?.selectedTab : "Re Upload"
  );

  const tabData = [
    { name: "Re Upload", component: <ReuploadFaceVerification /> },
    { name: "Re Upload Profile", component: <ReuploadProfileVerification /> },
    { name: "Face Verification", component: <FaceVerification /> },
    { name: "Verification Requests", component: <VerificationRequestsTable /> },
  ];

  return (
    <div>
      <PageTitle
        activeMenu="Face Verification Requested"
        motherMenu="Face Verification"
      />
      <Card>
        <Card.Body>
          <div className="default-tab">
            <Tab.Container
              activeKey={selectedTab}
              onSelect={(key) => {
                if (!key) return;
                setSelectedTab(key);
                const rest = { ...(location.state || {}) };
                delete rest.page;
                navigate(`${location.pathname}${location.search}`, {
                  replace: true,
                  state: { ...rest, selectedTab: key },
                });
              }}
              mountOnEnter
              unmountOnExit
            >
              <Nav as="ul" className="nav-tabs">
                {tabData.map((data) => (
                  <Nav.Item as="li" key={data.name}>
                    <Nav.Link eventKey={data.name}>{data.name}</Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
              <Tab.Content className="pt-3">
                {tabData.map((data) => (
                  <Tab.Pane eventKey={data.name} key={data.name}>
                    {data.component}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Tab.Container>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
